import React from 'react';

const ExtendRouters = ({ match }) => {
    if(ViewModel){
        let extendCache = ViewModel.getData('_nccloud_extend_cache_data');
        if(extendCache){
            for( let pop in extendCache){
                if(extendCache[pop] && extendCache[pop].localExtendRouter){
                    return extendCache[pop].localExtendRouter(match);
                }
            }
        }
        // console.log('客开的路由扩展', ViewModel.localExtendRouter);
        // return ViewModel.localExtendRouter ? ViewModel.localExtendRouter(match) : <h1>Hello {match.params.extend}!</h1>;
    }
    return null;
    
};

export default ExtendRouters;